@let ctx =
  {
    isPending: (isPending$ | async),
    isOnePageLayout: (isOnePageLayout$ | async),
    currentPage: (currentPage$ | async),
  };
<div class="element-wrapper" [ngStyle]="wrapperStyles">
  @if (labelEnabled && daySelectorMode === DaySelectorMode.DEFAULT) {
    <ng-container *ngTemplateOutlet="headerTitleTpl" />
  }
  <div
    class="flex w-full h-full overflow-hidden"
    [class.flex-col]="isMobile"
    [class.flex-row]="!isMobile"
  >
    @if (daySelectorMode === DaySelectorMode.CALENDAR) {
      <div class="pb-8">
        <div [class.invisible]="!labelEnabled">
          <ng-container *ngTemplateOutlet="headerTitleTpl" />
        </div>
        <blaze-calendar-header
          class="pb-24 pl-16 pr-8 block"
          [selectedCalendarDate]="selectedDate"
          [viewportMode]="viewportMode"
          [calendar]="calendarMonthView"
          [(isCalendarVisible)]="isCalendarVisible"
          (previousDay)="selectPreviousDate()"
          (nextDay)="selectNextDate()"
          (previousPeriod)="selectPreviousMonth()"
          (nextPeriod)="selectNextMonth()"
        />
        <blaze-calendar-dates-view
          #calendarMonthView
          class="pt-8"
          [class.hidden]="!isCalendarVisible"
          [viewportMode]="viewportMode"
          [datesWithEvents]="datesWithEvents$ | async"
          [selected]="selectedDate"
          (selectedChange)="selectCalendarDay($event)"
        />
      </div>
    }

    <div class="input" [ngStyle]="inputStyles">
      <div class="months-carousel">
        @if (daySelectorMode === DaySelectorMode.DEFAULT) {
          <div class="month-label">
            {{ selectedMonthLabel$ | async }}
          </div>
        }

        @if (daySelectorMode === DaySelectorMode.CALENDAR) {
          <label class="label flex-grow flex items-center gap-4">
            <span class="bat-header-title">{{ selectedDate | date: 'fullDate' }}</span>
          </label>
        }
      </div>

      <div
        class="days-carousel flex mb-16"
        [class.hidden]="daySelectorMode === DaySelectorMode.CALENDAR"
      >
        <button
          type="button"
          blazeTooltip="Previous"
          class="navigate"
          blazeClickable
          (click)="goToPrevPage()"
          [disabled]="(canGoToPrevPage$ | async) === false"
        >
          <mat-icon svgIcon="icon_chevron_left_16" />
        </button>
        <ul #daysList class="days-list" [class.selectable]="ctx.isOnePageLayout">
          @for (item of ctx.currentPage; track trackByIndex($index, item)) {
            <li
              class="day-item"
              [class.selected]="isDaySelected(item.day)"
              [class.with-slots]="item.timeSlots.length"
              [class.today]="item.isToday"
            >
              <div
                class="day-circle"
                blazeClickable
                (click)="selectDay(item.day)"
                data-cy="Scheduler:dayCircle"
              >
                <span class="number">{{ getDayNumber(item.day) }}</span>
                <span class="name">{{ getDayName(item.day) }}</span>
              </div>
            </li>
          }
        </ul>
        <button
          type="button"
          blazeTooltip="Next"
          class="navigate"
          blazeClickable
          (click)="goToNextPage()"
          [disabled]="(canGoToNextPage$ | async) === false"
        >
          <mat-icon svgIcon="icon_chevron_right_16" />
        </button>
      </div>

      <blaze-scroller class="grow">
        @if ((noSlotsInSelectedRange$ | async) === false) {
          <div
            class="slots-container"
            data-cy="Scheduler:slotsContainer"
            [class.lg:mt-24]="daySelectorMode === DaySelectorMode.CALENDAR"
          >
            @if (ctx.isOnePageLayout) {
              <div class="slots-list-single">
                <ng-container
                  *ngTemplateOutlet="slotsListTpl; context: { item: selectedScheduleDay$ | async }"
                />
              </div>
            } @else {
              <ul class="slots-list-multiple" [style]="slotsMultipleListStyles$ | async">
                @for (item of ctx.currentPage; track item) {
                  <li class="slots-list-multiple-item">
                    <ng-container *ngTemplateOutlet="slotsListTpl; context: { item: item }" />
                  </li>
                }
              </ul>
            }
          </div>
        } @else if (!ctx.isPending) {
          <div class="slots-container no-slots" data-cy="Scheduler:noAppointmentsHint">
            <span>{{ emptyListLabel }}</span>
          </div>
        }
      </blaze-scroller>

      @if (!ctx.isPending && !ctx.isOnePageLayout) {
        <div class="hint">
          <span class="hint-color"></span>
          No appointments available
        </div>
      }
    </div>
  </div>

  <ng-template #slotsListTpl let-item="item">
    <ul class="slots-list" [class.empty]="!item?.timeSlots?.length">
      @for (slot of item?.timeSlots || []; track slot) {
        <li
          class="appointment-item"
          blazeClickable
          (click)="onAction($event, slot)"
          data-cy="Scheduler:item"
        >
          <span class="overflow-hidden">{{ getHourLabel(slot.time) }}</span>
        </li>
      }
    </ul>
  </ng-template>
</div>

<ng-template #headerTitleTpl>
  <blaze-element-header
    [class.pl-16]="isCalendarMode"
    [color]="props?.style?.general?.title?.color1"
    [fontFamily]="props?.style?.titleBlock?.fontFamily"
    [fontSize]="props?.style?.titleBlock?.fontSize"
    [fontStyle]="props?.style?.titleBlock?.fontStyle"
    [fontWeight]="props?.style?.titleBlock?.fontWeight"
    [horizontalAlign]="props?.content?.title?.align"
    [icon]="props?.content?.title?.icon"
    [iconColor]="props?.content?.title?.iconColor?.color1"
    [iconPosition]="props?.content?.title?.iconPosition"
    [iconSize]="props?.style?.titleBlock?.iconSize"
    class="mb-16"
  >
    {{ labelText }}
  </blaze-element-header>
</ng-template>
